﻿const axios = require('axios');
import * as odpUtils from '../integrations/ODP/utils';

class Login {
    Init() {
        var inst = this;
        $('.jsUsersSigninBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.signin($(this));
            });
        });

        $('.jsUsersSigninBtnCheckout').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.checkoutSignIn($(this));
            });
        });

        $('.account-page-forms__top-error-message').on('click', '.resend-email-link', function (event) {
            event.preventDefault();
            inst.resend($(this));
        });

        $('.jsLoginGtmClick').each(function (i, e) {
            $(e).click(function (event) {
                var gtmData = $(this).data('gtmclick');
                if (gtmData !== null && window.dataLayer !== null) {
                    window.dataLayer.push(gtmData);
                }
            });
        });
    }

    signin(e) {
        let form = $(e).closest("form");
        let bodyFormData = new FormData();
        bodyFormData.set('Email', $("#LoginViewModel_Email", form).val());
        bodyFormData.set('Password', $("#LoginViewModel_Password", form).val());
        bodyFormData.set('RememberMe', $("#LoginViewModel_RememberMe", form).is(':checked'));
        bodyFormData.set('ReturnUrl', $("#ReturnUrl", form).val());
        bodyFormData.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());
        $('.loading-box').show();
        this.signinRequest(form, bodyFormData);
    }

    checkoutSignIn(e) {
        let form = $(e).closest("form");
        let bodyFormData = new FormData();
        bodyFormData.set('RememberMe', $("#RememberMe", form).is(':checked'));
        bodyFormData.set('Email', $("#Email", form).val());
        bodyFormData.set('Password', $("#Password", form).val());
        bodyFormData.set('ReturnUrl', $("#ReturnUrl", form).val());
        bodyFormData.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());
        $('.loading-box').show();
        this.signinRequest(form, bodyFormData);
    }

    signinRequest(form, bodyFormData) {
        axios({
            method: 'post',
            url: form[0].action,
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(function (response) {
            if (response.data.success == false) {
                var errorMessage = document.getElementById('login-signin-errormessage');
                errorMessage.style.display = "none";

                var email = document.getElementById('EmailError');
                var password = document.getElementById('PasswordError');
                if (errorMessage) {
                    errorMessage.innerText = '';
                    for (var error in response.data.errors) {

                        if (response.data.errors[error].key === "Email") {
                            email.innerText = response.data.errors[error].value;
                            $('#EmailError').parent().addClass('form-error');
                        }
                        if (response.data.errors[error].key === "Password") {
                            password.innerText = response.data.errors[error].value;
                            $('#PasswordError').parent().addClass('form-error');
                        }

                        //RESET
                        if (password.innerText === '') {
                            $('#PasswordError').parent().removeClass('form-error');
                        }
                        if (email.innerText === '') {
                            $('#EmailError').parent().removeClass('form-error');
                        }
                        if (response.data.errors[error].key === "LoginViewModel.Error" || response.data.errors[error].key === "LoginViewModel.Password") {
                            errorMessage.style.display = "flex";
                            $('#login-signin-errormessage').append(response.data.errors[error].value);
                        }
                        if (response.data.errors[error].key === undefined || response.data.errors[error].key === '') {
                            errorMessage.style.display = "flex";
                            $('#login-signup-errormessage').append(response.data.errors[error] + '<br />');
                        }

                    }
                }
            }
            else {
                odpUtils.TrackLogin(response.data.email, response.data.siteUserId, response.data.customerContactId);
                odpUtils.TrackCustomerInformation(
                    response.data.email, 
                    response.data.siteUserId, 
                    response.data.customerContactId,
                    response.data.salesOrg,
                    response.data.distChannel,
                    response.data.market)

                if (response.data.returnUrl) {
                    window.location.href = response.data.returnUrl;
                } else {
                    window.location.href = "/";
                }
            }
        })
            .catch(function (response) {
                document.getElementById('login-signin-errormessage').innerText = response;
            })
            .finally(function () {
                $('.loading-box').hide();
            });
        $('.resend-email-content').html('');
        $('.resend-email-content').hide();
    }


    convertToJsonObject(arrayData) {
        var indexed_array = {};

        $.map(arrayData, function (n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    }

    resend(e) {

        let form = $('.login-form')[0];
        let bodyFormData = $("#LoginViewModel_Email", form).val();

        axios({
            method: 'post',
            url: '/PublicApi/ResendConfirmation',
            data: { email: bodyFormData },
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response) {
                if (response.data) {
                    if (response.data.success) {
                        $('.resend-email-content').show();
                        $('.resend-email-content').html(response.data.message);
                    }
                    else {
                        $('.resend-email-content').html('');
                        $('.resend-email-content').hide();
                        $('#login-signin-errormessage').innerText = response.data.errors[0];
                    }
                }
            })
            .catch(function (response) {

            })
            .finally(function () {

            });
    }
}
$(document).ready(function () {
    var login = new Login();
    login.Init();
});